import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { EntityReducers } from '../../EntityReducers';
import { surveysThunks } from './SurveysThunks';
import { SurveyDetailsModel } from '@models/Surveys';

const entityAdapter = createEntityAdapter<SurveyDetailsModel>();

const slice = createSlice({
  name: EntityReducers.surveys,
  initialState: {
    ...getBaseState(entityAdapter),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([surveysThunks.getSurveyDetails, surveysThunks.cloneSurvey], builder);
    handleFulfilledAction(surveysThunks.getSurveyDetails, builder, (state, payload) => {
      entityAdapter.upsertOne(state, payload);
    });
    handleFulfilledAction(surveysThunks.cloneSurvey, builder, () => {});
  },
});

export const surveysReducer = {
  slice,
  entityAdapter,
  thunks: surveysThunks,
};
